export default __webpack_public_path__ + "static/contact-nav-ebd9ddb28edd97be9304e05b8d529dc5.svg";